"use client";

import React from "react";
import { Asterisk } from "lucide-react";
export default function Marquee() {
  const phrase = "EXISTIMOS PARA ADORAR A DIOS, EVANGELIZAR, DISCIPULAR CREYENTES Y MOSTRAR COMPASIÓN";

  // Repeating list to guarantee seamless marquee looping
  const items = Array.from({
    length: 8
  }, () => phrase);
  return <section id="missionmarquee" data-nav="light" aria-label="Declaración de Misión" className="acad-about-marquee relative w-full overflow-hidden border-y border-border bg-background py-5 md:py-6">
      <div className="relative flex w-full select-none items-center">
        <div className="acad-marquee-track flex shrink-0 items-center gap-6 whitespace-nowrap">
            {items.map((text, i) => <div key={i} data-index={i} className="flex shrink-0 items-center gap-6 pr-2 text-sm font-bold tracking-wider uppercase text-foreground md:text-base lg:text-lg">
                <span>{text}</span>
                <Asterisk className="size-4 shrink-0 text-destructive stroke-[2.5] md:size-5" aria-hidden="true" />
              </div>)}
        </div>
      </div>
    </section>;
}
